import authSlice from '~redux/slices/auth';
import dashboardSlice from '~redux/slices/dashboard';
import customerSlice from '~redux/slices/customer';
import navigationSlice from '~redux/slices/navigation';
import goldSlice from '~redux/slices/gold';
import branchSlice from '~redux/slices/branch';
import settingSlice from '~redux/slices/setting';
import adminSlice from './slices/admin';
import approvalSlice from './slices/approval';
import projectSlice from './slices/project';
import silverSlice from './slices/silver';

export default {
    ...authSlice.actions,
    ...dashboardSlice.actions,
    ...customerSlice.actions,
    ...navigationSlice.actions,
    ...goldSlice.actions,
    ...branchSlice.actions,
    ...settingSlice.actions,
    ...adminSlice.actions,
    ...approvalSlice.actions,
    ...projectSlice.actions,
    ...silverSlice.actions,
};
